var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#61A351",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.25 14.583 75 8.333l-6.25 6.25-6.25-6.25-6.25 6.25L50 8.333l-6.25 6.25-6.25-6.25-6.25 6.25L25 8.333v58.334H12.5v12.5c0 6.916 5.583 12.5 12.5 12.5h50c6.917 0 12.5-5.584 12.5-12.5V8.333l-6.25 6.25zm-2.083 64.584A4.179 4.179 0 0 1 75 83.333a4.179 4.179 0 0 1-4.167-4.166v-12.5h-37.5V20.833h45.834v58.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 29.166h25V37.5h-25zM66.667 29.166H75V37.5h-8.333zM37.5 41.666h25V50h-25zM66.667 41.666H75V50h-8.333z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.4998822463eaaa5b35e22327ddc85374.svg";
export { ForwardRef as ReactComponent };